/**
 * GeChiUI dependencies
 */
import { createContext, useContext } from '@gechiui/element';

/**
 * @type {import('react').Context<import('./types').Context>}
 */
export const FlyoutContext = createContext( {} );
export const useFlyoutContext = () => useContext( FlyoutContext );
